<template>
  <div :class="searchClass">
    <font-awesome-icon icon="search" />
    <input
      class="SearchBar__input"
      type="text"
      :placeholder="SEARCH_CHAPTER"
      @focus="onFocus"
      @blur="onBlur"
      @input="onChange(name, $event)"
    />  
  </div>
</template>

<script>
import fas from '@fortawesome/fontawesome-free-solid'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { GENERAL } from '../../locales/es'
export default {
  components: {
    FontAwesomeIcon,
  },
  props: {
    onChange: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      ...GENERAL,
      state: 'blur',
    }
  },
  computed: {
    fas() { return fas },
    searchClass() {
      return `SearchBar SearchBar--${this.state}`
    },
  },
  methods: {
    onFocus(){
      this.state = 'focus'
    },
    onBlur(){
      this.state = 'blur'
    },
  }
}
</script>

<style scoped>
.SearchBar {
  background: #FFF;
  border: 2px solid #bed1c7;
  border-radius: 3px;
  box-sizing: border-box;
  padding: 3px 0;
  position: relative;
  transition: all 0.2s;
  width: 380px;
}

.SearchBar > svg {
  color: #bed1c7;
  width: 42px;
}

.SearchBar--focus {
  box-shadow: 0 2px 8px 8px rgba(0,0,0,0.1);
  transform: scale(1.1, 1.1);
}

.SearchBar__input {
  border: none;
  color: #b8c1cf;
  font-family: Helvetica, Arial, sans-serif;
  font-size: 0.9em;
  line-height: 32px;
  margin: 0;
  width: 328px;
}

.SearchBar__input:focus {
  color: #3c4148;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchBar/SearchBar.vue